import axios from "axios";
import qs from "qs";
// import Config from "../../config/index";

const service = axios.create({
  // baseURL: "https://api.nanchongcity.com", // api的base_url
  timeout: 60000
});

//添加请求拦截器
service.interceptors.request.use(
  config => {
    if (config.method === "post") {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//添加响应拦截器
service.interceptors.response.use(
  res => {
    console.log(res);
    return res;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

export function post(url, params) {
  return new Promise((resolve, reject) => {
    service
      .post(url, params)
      .then(response => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          reject("网络请求出错...")
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function get(url, params) {
  return new Promise((resolve, reject) => {
    service
      .get(url, params)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export default {
  getOffcialSite() {
    return get("/api/offcialsite");
  },
  getProductList() {
    return get("/api/offcialsite/product");
  },

  getSolutionList() {
    return get("/api/offcialsite/solution");
  },

  getCaseList() {
    return get("/api/offcialsite/case");
  },
  getNewsList() {
    return get("/api/offcialsite/news");
  },
  getArticle(id, type) {
    return get("/api/offcialsite/article?id=" + id + "&type=" + type);
  },
  saveContact(params) {
    return post("/api/offcialsite/contact", params);
  },
  setAdRecord(params) {
    return post("/api/ad/record", params);
  },
  getCmsContent(id) {
    return get("/api/sp/notice/getById?id=" + id);
  },
  // H5访问统计上报（gcx-realtime-bus /appApi 匿名接口；绝对地址跨域，后端已开CORS）
  h5VisitReport(params) {
    return post("https://rt-api.steadan.com/appApi/statistics/h5Visit", params);
  }
};



// WEBPACK FOOTER //
// ./src/fetch/api.js